export function getPortalApiBackendUrl(vercelTargetEnv = process.env.VERCEL_TARGET_ENV) {
  switch (vercelTargetEnv) {
    case 'production':
      return 'https://pp-api.ashwellness.io'
    case 'staging':
      return 'https://pp-api.staging.ashwellness.io'
    case 'preview':
    case 'development':
    default:
      // localhost and preview environments route to dev portal-api.
      return 'https://pp-api.dev.ashwellness.io'
  }
}
